<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Reschedule / Skip'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (windowService.isDesktopRes) {
    <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper>


    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'What would you like to do?'" />
    </tidy-row>

    <tidy-button
      [text]="'Reschedule Job'"
      [action]="boundRescheduleJob"
      [disabled]="!booking"
      class="primary full-width" />

    <tidy-button
      [text]="'Skip Job'"
      [action]="boundSkipJob"
      [disabled]="!booking"
      class="secondary full-width" />

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
